import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  apiUrl = environment.apiUrl;
  _getBrokerNotifications = this.apiUrl + '/getBrokerAlerts';
  _markAsRead = this.apiUrl + '/markAsRead';
  _markAsUnread = this.apiUrl + '/markAsUnread';
  _archiveAlert = this.apiUrl + '/archiveAlert';

  token: any;
  header: any;

  constructor(
    private http: HttpClient
  ) { }

  private getHeaders(): HttpHeaders {
    this.token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
  }

  getBrokerNotifications(): Observable<any> {
    this.header = this.getHeaders();
    return this.http.get(this._getBrokerNotifications, { headers: this.header });
  }

  markAsRead(data: any): Observable<any> {
    this.header = this.getHeaders();
    return this.http.post(this._markAsRead, data, { headers: this.header });
  }

  markAsUnRead(data: any): Observable<any> {
    this.header = this.getHeaders();
    return this.http.post(this._markAsUnread, data, { headers: this.header });
  }

  archiveAlert(data: any): Observable<any> {
    this.header = this.getHeaders();
    return this.http.post(this._archiveAlert, data, { headers: this.header });
  }
}

